import { staticText } from '../../utils/translations/staticText';

// Comparison copy, block-local per the cms-blocks i18n convention.
// Default (`_`) is EN for both brands; `zh` overlays ZH-HK on MoneyHero.
export const TRANSLATIONS = staticText({
  compare: { _: 'Compare', zh: '比較' },
  compare_clear: { _: 'Clear', zh: '清除' },
  compare_page_title: { _: 'Compare Plans', zh: '比較保險產品' },
  // Two keys rather than one sentence split on a space: the ZH copy has no spaces, so a split
  // would put the whole string in the highlight treatment.
  compare_legend_highlight: { _: 'Blue', zh: '藍色' },
  // The EN copy carries its own leading space; ZH has none, and joining the two spans with a space
  // would print one inside the Chinese sentence.
  compare_legend_rest: {
    _: ' marks the highest coverage.',
    zh: '標示最高保障',
  },
  // Offer rows left unlabelled by the editor (the ticket's seeded set labels them this way).
  compare_exclusive_offer: { _: 'Exclusive Offer', zh: '獨家優惠' },
  compare_welcome_offer: { _: 'Welcome Offer', zh: '迎新優惠' },
  // A vertical that prompts rather than returning when nothing is selected.
  compare_empty_title: {
    _: 'Select at least two plans to compare',
    zh: '請選擇最少兩個產品作比較',
  },
  compare_empty_action: { _: 'Browse plans', zh: '瀏覽產品' },
  compare_add_plan: { _: 'Add Plan', zh: '新增產品' },
  // Credit card (BRD-02).
  compare_page_title_cards: { _: 'Compare Credit Cards', zh: '比較信用卡' },
  compare_count_cards: {
    _: 'Comparing :count card (up to :cap)|Comparing :count cards (up to :cap)',
    zh: '正在比較 :count 張信用卡（最多 :cap 張）|正在比較 :count 張信用卡（最多 :cap 張）',
  },
  compare_add_card: { _: 'Add a Card', zh: '新增信用卡' },
  compare_add_card_slot: { _: 'Add Card', zh: '加入信用卡' },
  compare_empty_title_cards: {
    _: 'Select at least two cards to compare',
    zh: '請選擇最少兩張信用卡作比較',
  },
  compare_empty_action_cards: { _: 'Browse Cards', zh: '瀏覽信用卡' },
  compare_choose_cards: { _: 'Choose Cards', zh: '選擇信用卡' },
  compare_search_placeholder_cards: {
    _: 'Search or select cards',
    zh: '搜尋或選擇信用卡',
  },
  compare_no_cards_found: { _: 'No cards found', zh: '找不到相關信用卡' },
  compare_cta_count_cards: { _: 'Compare :count', zh: '比較 :count 張' },
  compare_at_cap_cards: {
    _: 'You can compare up to :cap cards',
    zh: '最多可比較 :cap 張信用卡',
  },
  // The card's compare pill (BRD-02 FR-2.2.1): the label, its selected state, and its name.
  compare_added: { _: 'Added', zh: '已加入' },
  compare_toggle_label: { _: 'Compare :name', zh: '比較 :name' },
  compare_cta_more_cards: { _: 'Add :count more', zh: '再加 :count 張' },
  // The tray as a labelled region, and its polite announcements of what was added or removed.
  compare_tray_label: { _: 'Comparison selection', zh: '已選比較' },
  compare_announce_added: {
    _: ':name added to comparison',
    zh: '已加入比較：:name',
  },
  compare_announce_removed: {
    _: ':name removed from comparison',
    zh: '已從比較移除：:name',
  },
  compare_announce_added_count: {
    _: ':count added to comparison',
    zh: '已加入比較：:count 項',
  },
  compare_announce_removed_count: {
    _: ':count removed from comparison',
    zh: '已從比較移除：:count 項',
  },
  compare_breadcrumb_home: { _: 'Home', zh: '首頁' },
  compare_results_travel_insurance: { _: 'Travel Insurance', zh: '旅遊保險' },
  compare_results_credit_card: { _: 'Credit Cards', zh: '信用卡' },
  compare_back_to_top: { _: 'Back to top', zh: '返回頂部' },
  // The heading of the trip details box beside the plan cards (from 1280).
  compare_trip_details: { _: 'Trip Details', zh: '行程資料' },
  compare_choose_plans: { _: 'Choose Plans', zh: '選擇產品' },
  compare_search_placeholder: {
    _: 'Search or select plans',
    zh: '搜尋或選擇產品',
  },
  compare_no_plans_found: { _: 'No Plans Found', zh: '沒有相關產品' },
  compare_try_another_name: {
    _: 'Try a different plan name',
    zh: '請嘗試其他產品名稱',
  },
  compare_included: { _: 'Included', zh: '包括' },
  // A boolean attribute the plan does not carry, where the editor authored no copy for it.
  compare_not_included: { _: '✕', zh: '✕' },
  compare_remove_plan: { _: 'Remove :plan-name', zh: '移除 :plan-name' },
  compare_at_cap: {
    _: 'You can compare up to :cap plans',
    zh: '最多可比較 :cap 個產品',
  },
  compare_empty_value: { _: '-', zh: '-' },
  compare_scroll_left: { _: 'Show the previous plan', zh: '顯示上一個產品' },
  compare_scroll_right: { _: 'Show the next plan', zh: '顯示下一個產品' },
  // Checkout CTA by fulfilment path. Deliberately not the results card's labels: the
  // ticket sets these for this page in both markets.
  compare_cta_e2e: { _: 'Apply Now', zh: '立即投保' },
  compare_cta_clickout: { _: 'Buy Now', zh: '官網投保' },
  compare_expand_all: { _: 'Expand all', zh: '全部展開' },
  compare_collapse_all: { _: 'Collapse all', zh: '全部收合' },
});
